import { Button } from "@mui/material";
import { BaseConsignment, EventCode, useUserSetting } from "@sal/onevent-portal";
import { SystemName } from "../../constants/systemname";
import { EMPTY_STRING } from "../../utilities";
import { ObjectLocation, ObjectParty, OnEventApiResponse } from "@origin/platform-types";
import dayjs from "dayjs";

export function ConsignmentMakeClaim({ data, currentUser, receiver }: {
	data?: BaseConsignment;
	currentUser: OnEventApiResponse<ObjectParty>;
	receiver?: ObjectLocation;
}) {
	const [claimFormBaseURL, _handleUpdate, settingQuery] = useUserSetting({
		settingSystemName: SystemName.Setting.PlumsailClaimFormBaseURL,
		settingTypeSystemName: "Value"
	});
	
	const handleOnClick = () => {
		const statePostcode = [receiver?.state, receiver?.postcode].filter(sp => sp && sp !== EMPTY_STRING).join(" ");
		const consigneeAddress = [
			receiver?.address1,
			receiver?.address2,
			receiver?.suburb,
			statePostcode
		].filter(sp => sp && sp !== EMPTY_STRING).join(", ");
		const deliveryDate = data?.events?.find(event => event.eventCode === EventCode.Consignment.Delivered)?.eventDate;

		const params = new URLSearchParams({
			ContactName: currentUser?.data?.fullName ?? "",
			CustomerName: data?.freightPayer?.fileAs ?? "",
			EmailAddress: currentUser?.data?.email ?? "",
			DocketNumber: data?.reference ?? "",
			Consignee: receiver?.locationName ?? "",
			ConsigneeAddress: consigneeAddress ?? "",
			DeliveryDate: deliveryDate ? dayjs(deliveryDate).format("MM/DD/YYYY") : ""
		});
		
		window.open(`${claimFormBaseURL}?${params.toString()}`);
	};

	return (
		<Button
			variant="contained"
			onClick={handleOnClick}
			disabled={claimFormBaseURL == null || settingQuery.isLoading || settingQuery.isError}
		>
			Make Claim
		</Button>
	);
}
